"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var pkg = require("../../package.json");
var DataFilter = require("../filters/DataFilter");
module.exports = /*#__PURE__*/function () {
  function BaseFirebaseDB(pathConfig, plainToClassHook, classToPlainHook, classTransformOptions) {
    var _this = this;
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    (0, _classCallCheck2["default"])(this, BaseFirebaseDB);
    this.isDebugEnabled = false;
    if (options.isDebugEnabled === true) {
      this.isDebugEnabled = options.isDebugEnabled;
    }
    this.idName = pathConfig.idName || "id";
    this.log("FirebaseDataManager v", pkg.version);
    this.classTransformOptions = classTransformOptions;
    // this.log("BaseFirebaseDB: classTransformOptions = ", classTransformOptions)
    //plainToClassHook is a workaround for class-transformer issue where it doesn't work for nested objects when it's used from external module like this one
    //user must pass the local plainToClass function from the parent project for nested objects to be transformed correctly
    this.plainToClassHook = function (clazz, data, options) {
      // this.applyOptions(args)
      // this.log("plainToClassHook: args = ", ...args)
      var result = plainToClassHook ? plainToClassHook(clazz, data, _this.classTransformOptions) : data;
      // this.log("plainToClassHook: result = ", result)
      _this.onLoadedFromDb(result, options);
      return result;
    };
    this.classToPlainHook = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this.applyOptions(args);
      var object = args[0];
      var fieldValueMap = _this.classToPlainBefore(object);
      var result = classToPlainHook ? classToPlainHook.apply(void 0, args) : args[0];
      _this.classToPlainAfter(result, fieldValueMap);
      // this.log("classToPlainHook: result = ", result)
      return result;
    };
    this.setupMethodsFromPaths(pathConfig);
  }
  (0, _createClass2["default"])(BaseFirebaseDB, [{
    key: "onLoadedFromDb",
    value: function onLoadedFromDb(result) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!result) {
        return;
      }
      this.callMethod(result, "startSchemaMigration", options);
      this.callMethod(result, "onLoadedFromDb", options);
    }
  }, {
    key: "callMethod",
    value: function callMethod(object, methodName) {
      if (typeof object[methodName] === "function") {
        for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }
        return object[methodName].apply(object, args);
      }
    }
  }, {
    key: "classToPlainBefore",
    value: function classToPlainBefore(object) {
      return null;
    }
  }, {
    key: "classToPlainAfter",
    value: function classToPlainAfter(object, fieldValueMap) {}
  }, {
    key: "getPrototype",
    value: function getPrototype() {
      return this.prototypeInstance;
    }
  }, {
    key: "setupMethodsFromPaths",
    value: function setupMethodsFromPaths(fbPathsConfig) {
      var _this2 = this;
      var crudConfig = this.createCRUDConfig(fbPathsConfig);
      this.prototypeInstance = this.getPrototype() || crudConfig.prototype || BaseFirebaseDB.prototype;
      delete crudConfig.prototype;

      // this.log("setupMethodsFromPaths: crudConfig = ", crudConfig)
      var prototype = this.getPrototype();
      Object.keys(crudConfig).forEach(function (methodName) {
        prototype[methodName] = _this2.generateMethodByName(methodName, crudConfig);
      });
      prototype.getRawPathForMethodName = function (methodName) {
        var path = fbPathsConfig[methodName][0];
        path = path.replace(/this\./g, "");
        return path;
      };
    }
  }, {
    key: "generateMethodByName",
    value: function generateMethodByName(methodName, fbPathsConfig) {
      var _this3 = this;
      return function () {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        //if it's CUD method we can have two situation:
        //param1..paramN, object
        //param1..paramN, primitive
        //
        //if it's an object, then we expect paramN to be omitted from the input
        //but we need to ensure the number of parameters stays consistent in both cases

        // this.log("methodName: ", methodName, "fbPathsConfig: ", fbPathsConfig)

        var finalArgs = args.slice();
        var data;
        var data2;
        var path = fbPathsConfig[methodName][0];
        var clazz = fbPathsConfig[methodName][1];
        var pathOptions = fbPathsConfig[methodName][2] || {};
        var index = -1;
        var indexExtra = 0;
        var isApi = methodName.startsWith("api");
        var isAggregate = _this3.isAggregateMethod(methodName);
        var isStorage = methodName.startsWith("storage");
        var isCud = _this3.isCUDmethod(methodName);
        var isBatch = methodName.startsWith("batch");
        var isTransaction = methodName.startsWith("transaction");
        var isDeleteAll = methodName.startsWith("deleteAll");
        var isListPager = methodName.startsWith("get") && methodName.endsWith("ListPager");
        if (isAggregate) {
          pathOptions = clazz;
        }

        //we treat last arg as an options object and spread it.
        var o = {};
        var lastArg = args[args.length - 1];
        if (lastArg && (0, _typeof2["default"])(lastArg) === "object") {
          o = lastArg;
        }
        var options = _objectSpread(_objectSpread({
          methodName: methodName,
          args: args
        }, o), pathOptions);

        //we assume that data is the first non-primitive argument
        var dataIndex = 0;
        var _iterator = _createForOfIteratorHelper(finalArgs),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _arg = _step.value;
            if ((0, _typeof2["default"])(_arg) === "object" || typeof _arg === "function") {
              data = _arg;
              break;
            }
            dataIndex++;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (data instanceof DataFilter) {
          options.dataFilter = data;
        }
        // if (finalArgs.length > 0) {
        //     data = finalArgs[finalArgs.length - 1]
        // }

        var isObject = (0, _typeof2["default"])(data) === 'object';
        if (isObject && isCud) {
          var docIdFromPath = _this3.documentIdFromPath(path);
          if (docIdFromPath) {
            // For cases when the doc id is defined in the path.
            if (data[_this3.idName] && data[_this3.idName] !== docIdFromPath) {
              throw new Error("Id inconsistency error: both path and data defines document id which don't match. Consider removing id from the data or from the path. data.id = ".concat(data[_this3.idName], ", id from path = ").concat(docIdFromPath, ", path = ").concat(path));
            }
            _this3.log("BaseFirebaseDB: docIdFromPath = ", docIdFromPath);
            data[_this3.idName] = docIdFromPath;
            indexExtra++;
          }
          _this3.ensureIdSet(data);
          finalArgs.splice(dataIndex, 0, data[_this3.idName]); //insert id as the last argument before data object
          finalArgs.push(data);
        }

        // let finalArgs2 = []
        // let isIdAdded = false
        // let segments = path.split("/").filter(segment => segment.startsWith("{") && !segment.startsWith("{this"))
        // let firstObject = 0
        // let nonObjectArgs = []
        // let argsIndex = 0
        // for(let arg of args){
        //     if(typeof arg === "object"){
        //         firstObject = arg
        //         options = args[argsIndex + 1] || firstObject
        //         break
        //     } else {
        //         nonObjectArgs.push(arg)
        //     }
        //     argsIndex++
        // }

        // let curArgIndex = 0
        //
        // for(let segment of segments){
        //     let currentArg = nonObjectArgs[curArgIndex]
        //
        //     if(segment.startsWith("{?")){
        //         let paramName = segment.replace("{", "").replace("}", "")
        //         if(firstObject && firstObject[paramName]){
        //             currentArg = firstObject[paramName]
        //             curArgIndex--
        //         }
        //     }
        //     if(!currentArg){
        //         if(!isIdAdded && firstObject){
        //             isIdAdded = true
        //             this.ensureObjectDataId(firstObject, path)
        //             currentArg = firstObject[this.idName]
        //         } else {
        //             throw new Error(`BaseFirebaseDB: invalid arg at index ${curArgIndex}: it's either null or undefined which is not allowed: ${methodName}, args = [${args.join(',')}]`)
        //         }
        //     }
        //
        //     finalArgs2.push(currentArg)
        //
        //     curArgIndex++
        // }

        // this.log("BaseFirebaseDB: finalArgs = ", finalArgs)
        _this3.log("BaseFirebaseDB: path = ", path);
        var parsedPathCommand = path.replace(/{([^{]*)}/g, function (match) {
          if (match.startsWith("{this.")) {
            var paramName = match.replace("{this.", "").replace("}", "");
            return options[paramName] || _this3[paramName];
          }
          match = match.replace("{", "").replace("}", "");
          var shouldCheckInProps = false;
          if (match.startsWith("?")) {
            shouldCheckInProps = true;
            match = match.substring(1);
          }
          // this.log("BaseFirebaseDB: parsePath shouldCheckInProps = ", shouldCheckInProps, ", match = ", match, ", data[match] = ", data[match], ", data = ", data)
          if (shouldCheckInProps && isObject && data[match] != null) {
            return data[match];
          }
          index++;
          return finalArgs[index];
        });
        var splitCommand = parsedPathCommand.split(";");
        var parsedPath = splitCommand[0];
        splitCommand.splice(0, 1);
        _this3.log("BaseFirebaseDB: ".concat(methodName, "(").concat(args.join(","), "): \"").concat(parsedPath, "\", arguments: "), args);
        // this.log(`BaseFirebaseDB: ${methodName} arguments: `, args)

        var lastIndex = index + 1;
        if (isCud && isObject && index + 1 + indexExtra > args.length) {
          // || index + 1 > args.length) {
          throw new Error("BaseFirebaseDB: parameters mismatch. Expected ".concat(index + 1, " parameters but was provided ").concat(args.length, ": ").concat(methodName, "(").concat(args.join(','), "): \"").concat(path, "\""));
        }
        if ((isListPager || isDeleteAll) && finalArgs.length < index + 1) {
          throw new Error("BaseFirebaseDB: parameters mismatch. Expected ".concat(index + 2, " parameters but was provided ").concat(args.length, ": ").concat(methodName, "(").concat(args.join(','), "): \"").concat(path, "\""));
        }
        if (isListPager) {
          data = finalArgs[index + 1];
          data2 = finalArgs[index + 2];
        }
        for (var i = 0; i < lastIndex; ++i) {
          var arg = args[i];
          if (arg === null || arg === undefined) {
            throw new Error("BaseFirebaseDB: invalid arg at index ".concat(i, ": it's either null or undefined which is not allowed: ").concat(methodName, ", args = [").concat(args.join(','), "]"));
          }
        }

        // let finalArgs = args.slice();
        // let data
        // let path = fbPathsConfig[methodName][0];
        // let clazz = fbPathsConfig[methodName][1];
        // let index = -1;
        // let isApi = methodName.startsWith("api")
        // let isStorage = methodName.startsWith("storage")
        // let isCud = this.isCUDmethod(methodName)
        // let isBatch = methodName.startsWith("batch")
        // let isTransaction = methodName.startsWith("transaction")
        //
        // let wildcardPatter = /{([^{]*)}/g
        //
        // let wildcardCount = this.countWildcardCount(path, wildcardPatter)
        // let wildcardValuesCount = this.countWildcardValuesCount(args)
        // let dataIndex = -1
        //
        //
        // while (dataIndex < finalArgs.length - 1){
        //     dataIndex++
        //     data = finalArgs[dataIndex]
        //     if(typeof data === "object" || typeof data === "function"){
        //         break
        //     }
        // }
        // let isObject = typeof data === 'object'
        //
        //
        //
        // this.log("BaseFirebaseDB: counted: wildcardCount = ", wildcardCount, ", wildcardValuesCount = ", wildcardValuesCount, ", dataIndex = ", dataIndex, ", data = ", data)
        //
        // if(isObject && isCud){
        //     let docIdFromPath = this.documentIdFromPath(path)
        //     if(docIdFromPath){
        //         // For cases when the doc id is defined in the path.
        //         if(data[this.idName] && data[this.idName] !== docIdFromPath){
        //             throw new Error(`Id inconsistency error: both path and data defines document id which don't match. Consider removing id from the data or from the path. data.id = ${data[this.idName]}, id from path = ${docIdFromPath}, path = ${path}`)
        //         }
        //         this.log("BaseFirebaseDB: docIdFromPath = ", docIdFromPath)
        //         data[this.idName] = docIdFromPath
        //     }
        // }
        //
        // if(wildcardCount !== wildcardValuesCount){
        //     let isArray = Array.isArray(data)
        //
        //     if(isObject && !isArray){
        //         this.ensureIdSet(data)
        //         finalArgs.splice(dataIndex, 0, data[this.idName])
        //         wildcardValuesCount++
        //         this.log("BaseFirebaseDB: found object - inc wildcardValuesCount = ", wildcardValuesCount)
        //     }
        // }
        //
        // if(isCud || isBatch || isTransaction){
        //     wildcardCount++
        //     wildcardValuesCount++
        // }
        // this.log("BaseFirebaseDB: data = ", data, ", finalArgs = ", finalArgs, ", wildcardCount = ", wildcardCount, ", wildcardValuesCount = ", wildcardValuesCount, ", dataIndex = ", dataIndex)
        //
        //
        // if ((isCud || isBatch || isTransaction) && wildcardCount !== wildcardValuesCount || wildcardCount > wildcardValuesCount) {
        //     throw new Error(`BaseFirebaseDB: parameters mismatch. Expected ${wildcardCount} parameters but was provided ${wildcardValuesCount}: ${methodName}(${args.join(',')}): "${path}"`)
        // }

        // let parsedPathCommand = path.replace(wildcardPatter, match => {
        //     if(match.startsWith("{this.")){
        //         let paramName = match.replace("{this.", "").replace("}", "")
        //         return this[paramName]
        //     }
        //     index++
        //     return finalArgs[index]
        // });
        //
        // let splitCommand = parsedPathCommand.split(";")
        // let parsedPath = splitCommand[0]
        // splitCommand.splice(0, 1)

        // this.log(`BaseFirebaseDB: ${methodName}(${args.join(',')}): "${parsedPath}", arguments: `, args)
        // this.log(`BaseFirebaseDB: ${methodName} arguments: `, args)
        // this.log("BaseFirebaseDB: isCud = ", isCud, ", isBatch = ", isBatch, ", index = ", index, ", indexAdjust = ", indexAdjust, ", args.length = ", args.length)

        // if ((isCud || isBatch) && index + indexAdjust !== args.length || index + 1 > args.length) {
        //     throw new Error(`BaseFirebaseDB: parameters mismatch. Expected ${index + 1} parameters but was provided ${args.length}: ${methodName}(${args.join(',')}): "${path}"`)
        // }

        try {
          //callback to override in subclasses. Currently for logging purposes
          _this3.onMethodCalled(methodName, parsedPath, data, clazz, options);
        } catch (e) {
          console.error(e);
        }
        if (methodName.endsWith("Path")) {
          return parsedPath;
        }
        if (isApi) {
          return _this3.executeApiMethod(methodName, parsedPath, data, clazz, options);
        }
        if (isStorage) {
          return _this3.executeStorageMethod(methodName, parsedPath, data, clazz, options);
        }

        //getRefForMethodName must be after API methods
        // this.log("BaseFirebaseDB: methodName = ", methodName, ", parsedPath = ", parsedPath)
        var ref = _this3.getRefForMethodName(methodName, parsedPath);
        if (methodName.endsWith("Ref")) {
          return ref;
        }
        if (methodName.startsWith("get") && (methodName.endsWith("List") || methodName.endsWith("Group"))) {
          return _this3.fetchList(ref, splitCommand, clazz, options);
        }
        if (methodName.startsWith("get") && methodName.endsWith("Count")) {
          return _this3.aggregationCount(ref, options);
        }
        if (methodName.startsWith("getAggregateAverage") || methodName.startsWith("get") && methodName.endsWith("Average")) {
          return _this3.aggregationAverage(ref, options);
        }
        if (methodName.startsWith("getAggregateSum") || methodName.startsWith("get") && methodName.endsWith("Sum")) {
          return _this3.aggregationSum(ref, options);
        }
        if (methodName.startsWith("get") && (methodName.endsWith("ListPager") || methodName.endsWith("GroupPager"))) {
          if (typeof data === "number") {
            data = _this3.createDefaultDataFilter(data);
          }
          if (data && typeof data.setDebugEnabled === "function") {
            data = data.setDebugEnabled(_this3.isDebugEnabled);
          }
          return _this3.fetchListPager(ref, data, clazz, options);
        }
        if (methodName.startsWith("get")) {
          return _this3.fetch(ref, clazz, options);
        }
        if (methodName.startsWith("create")) {
          return _this3.create(ref, data, clazz, options);
        }
        if (methodName.startsWith("batchCreate")) {
          return _this3.batchCreate(ref, data, clazz, options);
        }
        if (methodName.startsWith("batchSet")) {
          return _this3.batchSet(ref, data, clazz, options);
        }
        if (methodName.startsWith("batchUpdate")) {
          return _this3.batchUpdate(ref, data, clazz, options);
        }
        if (methodName.startsWith("batchDelete")) {
          return _this3.batchDelete(ref, data, clazz, options);
        }
        if (methodName.startsWith("transaction")) {
          if (typeof data !== "function") {
            throw new Error("updateInTransaction expects callback of type function. Actual callback was " + data);
          }
          if (methodName.startsWith("transactionUpdate")) {
            return _this3.transactionUpdate(ref, data, clazz, options);
          }
          if (methodName.startsWith("transactionSet")) {
            return _this3.transactionSet(ref, data, clazz, options);
          }
        }
        if (methodName.startsWith("update")) {
          try {
            return _this3.update(ref, data, clazz, options);
          } catch (error) {
            var replacer = function replacer(key, value) {
              return typeof value === 'undefined' ? "UNDEFINED" : value;
            };
            console.error("meh... something failed: methodName = ", methodName, ", path = ", path, ", data = ", data, ", dataJson = ", JSON.stringify(data, replacer));
            throw error;
          }
        }
        if (methodName.startsWith("set")) {
          return _this3.set(ref, data, clazz, options);
        }
        if (methodName.startsWith("deleteAll")) {
          return _this3.deleteAll(ref, data, clazz, options);
        }
        if (methodName.startsWith("delete")) {
          return _this3["delete"](ref, data, clazz, options);
        }
        if (methodName.startsWith("onSnapshot")) {
          if (typeof data !== "function") {
            throw new Error("onSnapshot expects callback of type function. Actual callback was " + data);
          }
          return _this3.onSnapshot(ref, clazz, data, options);
        }
        throw new Error("Unknown method: ".concat(methodName, ". Please make sure to provide a method that starts with 'get', 'apiGet', 'apiPost', 'apiDelete', 'storage', 'batch' or 'transactionUpdate'"));
      };
    }
  }, {
    key: "onMethodCalled",
    value: function onMethodCalled(methodName, parsedPath, data, clazz, options) {}
  }, {
    key: "isCUDmethod",
    value: function isCUDmethod(methodName) {
      return methodName.startsWith("create") || methodName.startsWith("set") || methodName.startsWith("update") || methodName.startsWith("delete");
    }
  }, {
    key: "isAggregateMethod",
    value: function isAggregateMethod(methodName) {
      return methodName.startsWith("getAggregate") || this.isAggregateCountMethod(methodName) || methodName.startsWith("get") && methodName.endsWith("Sum") || methodName.startsWith("get") && methodName.endsWith("Average");
    }
  }, {
    key: "isAggregateCountMethod",
    value: function isAggregateCountMethod(methodName) {
      return methodName.startsWith("getAggregateCount") || methodName.startsWith("get") && methodName.endsWith("Count");
    }
  }, {
    key: "createCRUDConfig",
    value: function createCRUDConfig(fbPathsConfig) {
      var _this4 = this;
      var crudConfig = Object.assign({}, fbPathsConfig);
      Object.keys(crudConfig).forEach(function (methodName) {
        var listMethodName = methodName + "List";
        // let counterMethodName = methodName + "Counter"
        // let counterMethodDebounceEventsName = methodName + "CounterDebounceEvents"

        var configItem = (0, _toConsumableArray2["default"])(crudConfig[methodName]);
        var options = configItem[2] || {};
        if (_this4.isAggregateMethod(methodName) && !_this4.isAggregateCountMethod(methodName)) {
          options = configItem[1] || {};
          var path = configItem[0];
          // parse path to remove the aggregateBy field from the path and put it into options object. Example: "path/to/am/object:field" => "path/to/am/object", {aggregateBy: "field"}. Throw if aggregatedBy is not set either in path not in options at the end

          var aggregateBy = path.split(":")[1];
          //ensure that aggregateBy doesn't contain any slashes
          if (aggregateBy && !aggregateBy.includes("/")) {
            path = path.split(":")[0];
            if (options.aggregateBy && options.aggregateBy !== aggregateBy) {
              throw new Error("BaseFirebaseDB: conflicting aggregateBy values provided for " + methodName + " in both path and options. Make sure the values you provide are the same or provide it only in one place: either in path separated by ':' ('path/to/collection:field') or in options as a second parameter in the method config [path, {aggregateBy: 'field'}]");
            }
            options.aggregateBy = aggregateBy;
          }
          if (!options.aggregateBy) {
            throw new Error("BaseFirebaseDB: aggregateBy is not set for " + methodName + ". Make sure to provide it either in path separated by ':' ('path/to/collection:field') or in options as a second parameter in the method config [path, {aggregateBy: 'field'}]");
          }
          configItem[0] = path;
          configItem[1] = options;
          crudConfig[methodName] = configItem;
        }
        var addList = options.list !== false;
        var addListPager = options.listPager !== false;
        var addGet = options.get !== false;
        var addWrite = options.write !== false;
        var addUpdate = addWrite && options.update !== false;
        var addSet = addWrite && options.set !== false;
        var addCreate = addWrite && options.create !== false;
        var addDelete = addWrite && options["delete"] !== false;
        var addDeleteAll = addDelete && options.addDeleteAll !== false;
        var addCounter = options.counter !== false;
        var addBatchSet = addWrite && options.batchSet === true;
        var addBatchCreate = addWrite && options.batchCreate === true;
        var addBatchDelete = addWrite && options.batchDelete === true;
        if (methodName.startsWith("get") && !methodName.endsWith("Ref") && !methodName.endsWith("Group") && !methodName.endsWith("GroupPager") && !methodName.endsWith("GroupRef") && !_this4.isAggregateMethod(methodName)) {
          //for each get* method we generate the remaining CRUD operations + Ref witch returns database reference for the specified path

          if (!methodName.endsWith("List")) {
            var listRefMethodName = listMethodName + "Ref";
            var listPathMethodName = listMethodName + "Path";
            var pathSplit = configItem[0].split("/");
            pathSplit.pop();
            var listPath = pathSplit.join("/");
            configItem[0] = listPath;
            if (addList) crudConfig[listMethodName] = configItem;
            if (!crudConfig[listRefMethodName]) {
              crudConfig[listRefMethodName] = configItem;
            }
            if (!crudConfig[listPathMethodName]) {
              crudConfig[listPathMethodName] = configItem;
            }

            // if(!crudConfig[counterMethodName]){
            //     let counterPath = "/--counter-doc--/--counter--/counter"
            //     let counterDebounceEventsPath = counterPath + "/debounce_events/{eventId}"
            // }
          }

          var listPagerMethodName = listMethodName + "Pager";
          var addMethodName = methodName.replace("get", "create");
          var updateMethodName = methodName.replace("get", "update");
          var setMethodName = methodName.replace("get", "set");
          // let updateBatchMethodName = methodName.replace("get", "batchUpdate")
          var deleteMethodName = methodName.replace("get", "delete");
          var deleteAllMethodName = methodName.replace("get", "deleteAll");
          // let deleteBatchMethodName = methodName.replace("get", "batchDelete")
          var refMethodName = methodName + "Ref";
          var pathMethodName = methodName + "Path";
          if (addListPager) crudConfig[listPagerMethodName] = crudConfig[listMethodName];
          if (addCreate) crudConfig[addMethodName] = crudConfig[methodName];
          if (addUpdate) crudConfig[updateMethodName] = crudConfig[methodName];
          if (addSet) crudConfig[setMethodName] = crudConfig[methodName];
          if (addDelete) crudConfig[deleteMethodName] = crudConfig[methodName];
          if (addDeleteAll) crudConfig[deleteAllMethodName] = crudConfig[listMethodName];
          // crudConfig[updateBatchMethodName] = crudConfig[methodName]
          // crudConfig[deleteBatchMethodName] = crudConfig[methodName]
          crudConfig[refMethodName] = crudConfig[methodName];
          crudConfig[pathMethodName] = crudConfig[methodName];
          if (!addGet) delete crudConfig[methodName];
        } else if (methodName.startsWith("get") && methodName.endsWith("Group")) {
          var groupRefMethodName = methodName + "Ref";
          crudConfig[groupRefMethodName] = crudConfig[methodName];
        }
      });
      this.log("createCRUDConfig: crudConfig = ", crudConfig);
      return crudConfig;
    }
  }, {
    key: "getRefForMethodName",
    value: function getRefForMethodName(methodName, parsedPath) {
      return this.getRef(parsedPath);
    }
  }, {
    key: "getRef",
    value: function getRef(path) {
      throw new Error("getRef not implemented");
    }
  }, {
    key: "getDb",
    value: function getDb() {
      throw new Error("getDB not implemented");
    }
  }, {
    key: "fetch",
    value: function fetch(ref, clazz) {
      return Promise.reject("Fetch method not implemented");
    }
  }, {
    key: "fetchList",
    value: function fetchList(ref, splitCommands, clazz, options) {
      return Promise.reject("FetchList method not implemented");
    }
  }, {
    key: "aggregationCount",
    value: function aggregationCount(ref, options) {
      return Promise.reject("aggregationCount method not implemented");
    }
  }, {
    key: "aggregationAverage",
    value: function aggregationAverage(ref, options) {
      return Promise.reject("aggregationAverage method not implemented");
    }
  }, {
    key: "aggregationSum",
    value: function aggregationSum(ref, options) {
      return Promise.reject("aggregationSum method not implemented");
    }
  }, {
    key: "fetchListPager",
    value: function fetchListPager(ref, dataFilter, clazz, options) {
      return Promise.reject("fetchListPager method not implemented");
    }
  }, {
    key: "create",
    value: function create(ref, object, clazz, options) {
      return Promise.reject("Create method not implemented");
    }
  }, {
    key: "update",
    value: function update(ref, object, clazz, options) {
      return Promise.reject("Update method not implemented");
    }
  }, {
    key: "transactionUpdate",
    value: function transactionUpdate(ref, data, clazz, options) {
      return Promise.reject("ransactionUpdate method not implemented");
    }
  }, {
    key: "transactionSet",
    value: function transactionSet(ref, data, clazz) {
      return Promise.reject("transactionSet method not implemented");
    }
  }, {
    key: "set",
    value: function set(ref, object, clazz) {
      return Promise.reject("Set method not implemented");
    }
  }, {
    key: "delete",
    value: function _delete(ref, object, clazz) {
      return Promise.reject("Delete method not implemented");
    }
  }, {
    key: "deleteAll",
    value: function deleteAll(ref, keyName, keyValue, clazz) {
      return Promise.reject("deleteAll method not implemented");
    }
  }, {
    key: "onSnapshot",
    value: function onSnapshot(ref, clazz, callback) {
      return Promise.reject("Listen method not implemented");
    }
  }, {
    key: "batchUpdate",
    value: function batchUpdate(ref, objectList, clazz, options) {
      var _this5 = this;
      var promiseList = [];
      objectList.forEach(function (object) {
        promiseList.push(_this5.update(ref, object, clazz, options));
      });
      return Promise.all(promiseList);
    }
  }, {
    key: "batchCreate",
    value: function batchCreate(ref, objectList, clazz, options) {
      var _this6 = this;
      var promiseList = [];
      objectList.forEach(function (object) {
        promiseList.push(_this6.create(ref, object, clazz, options));
      });
      return Promise.all(promiseList);
    }
  }, {
    key: "batchSet",
    value: function batchSet(ref, objectList, clazz, options) {
      var _this7 = this;
      var promiseList = [];
      objectList.forEach(function (object) {
        promiseList.push(_this7.set(ref, object, clazz, options));
      });
      return Promise.all(promiseList);
    }
  }, {
    key: "batchDelete",
    value: function batchDelete(ref, objectList, clazz, options) {
      var _this8 = this;
      var promiseList = [];
      objectList.forEach(function (object) {
        promiseList.push(_this8["delete"](ref, object, clazz, options));
      });
      return Promise.all(promiseList);
    }
  }, {
    key: "createDefaultDataFilter",
    value: function createDefaultDataFilter() {}
  }, {
    key: "apiFetch",
    value: function apiFetch(path, data, clazz) {
      return Promise.reject("apiFetch method not implemented");
    }
  }, {
    key: "apiFetchList",
    value: function apiFetchList(path, clazz) {
      return Promise.reject("apiFetchList method not implemented");
    }
  }, {
    key: "apiPost",
    value: function apiPost(path, object) {
      return Promise.reject("apiPost method not implemented");
    }
  }, {
    key: "apiDelete",
    value: function apiDelete(path, object) {
      return Promise.reject("apiDelete method not implemented");
    }
  }, {
    key: "storageUploadInternal",
    value: function storageUploadInternal(path, file) {
      return Promise.reject("storageUpload method not implemented");
    }
  }, {
    key: "storageDownload",
    value: function storageDownload(downloadUrl) {
      return Promise.reject("storageDownload method not implemented");
    }
  }, {
    key: "storageMove",
    value: function storageMove(pathFrom, pathTo) {
      return Promise.reject("storageMove method not implemented");
    }
  }, {
    key: "storageCopy",
    value: function storageCopy(pathFrom, pathTo) {
      return Promise.reject("storageCopy method not implemented");
    }
  }, {
    key: "storageDelete",
    value: function storageDelete(path) {
      return Promise.reject("storageDelete method not implemented");
    }
  }, {
    key: "generateId",
    value: function generateId(length) {
      throw new Error("generateId not implemented");
    }
  }, {
    key: "ensureIdSet",
    value: function ensureIdSet(object, ref) {
      if (object && (0, _typeof2["default"])(object) === 'object' && !object[this.idName]) {
        var newId;
        if (ref && ref.path) {
          newId = this.documentIdFromPath(ref.path);
        }
        object[this.idName] = newId || this.generateId();
      }
    }
  }, {
    key: "documentIdFromPath",
    value: function documentIdFromPath() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var segments = path.split("/");
      if (segments.length > 0 && segments.length % 2 === 0) {
        var docId = segments[segments.length - 1];
        if (docId.indexOf("{") < 0 && docId.indexOf("}") < 0) {
          return docId;
        }
      }
      return null;
    }
  }, {
    key: "resToData",
    value: function resToData(doc, clazz) {
      throw new Error("resToData not implemented");
    }
  }, {
    key: "resArrayToData",
    value: function resArrayToData(res, clazz) {
      throw new Error("resArrayToData not implemented");
    }
  }, {
    key: "resArrayToDataArray",
    value: function resArrayToDataArray(res, clazz) {
      throw new Error("resArrayToDataArray not implemented");
    }
  }, {
    key: "resToDataArray",
    value: function resToDataArray(res, clazz) {
      throw new Error("resToDataArray not implemented");
    }
  }, {
    key: "log",
    value: function log() {
      if (this.isDebugEnabled) {
        var _console;
        (_console = console).log.apply(_console, arguments);
      }
    }
  }, {
    key: "logWarn",
    value: function logWarn() {
      if (this.isDebugEnabled) {
        var _console2;
        (_console2 = console).warn.apply(_console2, arguments);
      }
    }
  }, {
    key: "applyOptions",
    value: function applyOptions(args) {
      if (this.classTransformOptions) {
        args.push(this.classTransformOptions);
      }
    }
  }, {
    key: "executeApiMethod",
    value: function executeApiMethod(methodName, parsedPath, data, clazz, options) {
      if (methodName.startsWith("apiGet")) {
        return this.apiFetch(parsedPath, data, clazz, options);
      }
      if (methodName.startsWith("apiPost")) {
        return this.apiPost(parsedPath, data, clazz, options);
      }
      if (methodName.startsWith("apiDelete")) {
        return this.apiDelete(parsedPath, data, clazz, options);
      }
      this.logWarn("executeApiMethod: method not found: methodName = ", methodName);
    }
  }, {
    key: "executeStorageMethod",
    value: function executeStorageMethod(methodName, parsedPath, data, clazz, options) {
      if (methodName.startsWith("storageUpload")) {
        return this.storageUploadInternal(parsedPath, data, options);
      }
      if (methodName.startsWith("storageDownload")) {
        return this.storageDownload(parsedPath, data, clazz, options);
      }
      if (methodName.startsWith("storageCopy")) {
        return this.storageCopy(parsedPath, data, clazz, options);
      }
      if (methodName.startsWith("storageMove")) {
        return this.storageMove(parsedPath, data, clazz, options);
      }
      if (methodName.startsWith("storageDelete")) {
        return this.storageDelete(parsedPath, data, clazz, options);
      }
      this.logWarn("executeStorageMethod: method not found: methodName = ", methodName);
    }
  }, {
    key: "countWildcardCount",
    value: function countWildcardCount(path, wildcardPatter) {
      var wildcardCount = 0;
      path.replace(wildcardPatter, function (match) {
        if (!match.startsWith("{this.")) {
          wildcardCount++;
        }
      });
      return wildcardCount;
    }
  }, {
    key: "countWildcardValuesCount",
    value: function countWildcardValuesCount(args) {
      var wildcardValuesCount = 0;
      for (var i = 0; i < args.length; ++i) {
        var arg = args[i];
        var isObject = (0, _typeof2["default"])(arg) === 'object' || typeof arg === "function";
        if (!isObject) {
          wildcardValuesCount++;
        } else {
          break;
        }
      }
      return wildcardValuesCount;
    }
  }]);
  return BaseFirebaseDB;
}();